import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { OdontoDiagnosticViewModel } from 'src/app/model/odonto/diagnostic.view';
import { ODONTO_MODULE_CONSTANTS } from '../../odonto.constants';

@Component({
  selector: 'ms-odonto-diagnostic',
  templateUrl: './odonto.diagnostic.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoDiagnosticComponent,
      multi: true,
    },
  ],
})
export class OdontoDiagnosticComponent extends BaseValueAccessor<
  OdontoDiagnosticViewModel[]
> {
  readonly screen = ODONTO_MODULE_CONSTANTS;
  @Input() turn = -1;
  @Input() patient = -1;
  @Input() readonly = false;

  removeDiagnostic = (idx: number) => {
    this.value.splice(idx, 1);
  };
}
